import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { AccountManagementEvent } from '@/services/analytics/events';

@Component({
    name: 'CmgLeaveChipotleUModal',
})
export default class CmgLeaveChipotleUModal extends Vue {
    isLeavingChipotleU = false;
    formSubmissionErrorMessage = '';

    async mounted() {
        this.formSubmissionErrorMessage = '';
    }

    get visible(): boolean {
        return this.$appStore.state.ui.modals.leaveChipotleUModal.visible;
    }

    get args() {
        return this.$appStore.state.ui.modals.leaveChipotleUModal.args;
    }

    get isLeavingRewards(): boolean {
        return this.args?.isLeavingRewards || false;
    }

    get isMobile(): boolean {
        return this.$services.ui.isMobile();
    }

    get modalTitle(): string {
        return this.isLeavingRewards
            ? "ARE YOU SURE YOU WANT TO LEAVE REWARDS AND CHIPOTLE U?"
            : "ARE YOU SURE YOU WANT TO LEAVE CHIPOTLE U?";
    }

    get modalDescription(): string {
        return this.isLeavingRewards
            ? "Leaving Rewards will also \n unenroll you from Chipotle U."
            : "You will still be enrolled in Chipotle Rewards.";
    }

    async onLeaveChipotleU(): Promise<void> {
        if (this.isLeavingChipotleU) {
            return;
        }

        this.isLeavingChipotleU = true;
        this.formSubmissionErrorMessage = '';

        try {
            await this.$services.customer.unregisterStudentStatus();
            if (this.isLeavingRewards) {
                this.$services.reward.clearRewards();

                await this.$services.loyalty.unenrollInLoyalty();
                await this.$services.customer.updateCustomer({
                    hasSeenRewardsGenOnboarding: false,
                    hasSeenRewardsExchOnboarding: false
                });
            }

            this.$services.customer.setProfileSubscriptionChangeOnly(true);
            await this.$services.customer.refreshCustomerProfileInfo(true, false, true);
            this.$services.ui.setModalVisibility('toast', true, {
                body: this.isLeavingRewards ? 'You are no longer enrolled in Rewards.' : 'You are no longer enrolled in Chipotle U.',
                title: '',
                isUpdatedVersion: true,
                bodyOnly: true,
                visibleTimeLength: 3000,
                icon: this.$appStore.state.cms.images.icons.pepperBadge.default
            });
            this.onClose();
        } catch (err) {
            this.formSubmissionErrorMessage = this.isLeavingRewards
                ? 'Error trying to leave Rewards'
                : 'Error trying to leave Chipotle U';
        } finally {
            this.isLeavingChipotleU = false;
        }
    }

    onClose() {
        this.$services.ui.setModalVisibility('leaveChipotleUModal', false);
        this.$services.ui.focusBack();
    }
}